import { render } from "./NewCustomInvoice.vue?vue&type=template&id=8f5b8126&scoped=true"
import script from "./NewCustomInvoice.vue?vue&type=script&lang=js"
export * from "./NewCustomInvoice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5b8126"]])

export default __exports__